import React, {useState} from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {findIconDefinition} from '@fortawesome/fontawesome-svg-core';
import {ToolTipCell} from 'components/ToolTipCell';
import {ExitModal} from '../../../Modals';

const absoluteLink = /^https?:\/\//i;

/**
 * Component to handle document links with exit modal
 */
export const DocumentsCell = ({settings, styleSheet, value, column}) => {
  const [showExitModal, setShowExitModal] = useState(false);
  const [documentLink, setDocumentLink] = useState('');

  const handleDocumentClick = (e) => {
    e.preventDefault();
    setDocumentLink(e.currentTarget.href);
    setShowExitModal(true);
  };

  const handleOpenDocument = () => {
    window.open(documentLink, '_blank', 'noopener,noreferrer');
    setShowExitModal(false);
  };

  const handleHide = () => {
    setShowExitModal(false);
  };

  const defaultDocumentMeta = {
    name: 'Coverage Document',
    label: 'Coverage Document',
    icon: {
      prefix: 'far',
      name: 'file',
    },
  };

  return (
    <>
      <div>{
        column.meta.documents.map((documentMeta, key) => {
          //Find document by matching document type name in the documentMeta object
          let document = value.find((doc) => {
            return doc.documentTypes.some((type) => type.name === documentMeta.name);
          });

          //If not found, find primary document
          if (!document && documentMeta.name === defaultDocumentMeta.name) {
            document =  value.find((doc) => {
              return doc.isPrimary === true;
            });
          }

          // Merge defaultDocumentMeta only if documentMeta is missing properties
          if (!documentMeta.label) {
            documentMeta = {...defaultDocumentMeta, ...documentMeta};
          }

          // If no icon is specified, use default
          if (!documentMeta.icon) {
            documentMeta.icon = defaultDocumentMeta.icon;
          }

          const icon = findIconDefinition({prefix: documentMeta.icon.prefix, iconName: documentMeta.icon.name});
          return (
            <React.Fragment key={`${key}-${documentMeta.label}`}>
              {document && document.documentTypes.length > 0 && absoluteLink.test(document.source) ? (
                <a
                  onClick={handleDocumentClick}
                  href={document.source}
                  rel='noopener noreferrer'
                >
                  <FontAwesomeIcon icon={icon}/>{documentMeta.label}
                </a>
              ) : (
                <ToolTipCell
                  placement={'bottom'}
                  styleSheet={styleSheet}
                  text={settings.content.unavailableDocumentHoverCoverage}
                  placeholder={(<span><FontAwesomeIcon icon={icon} />{documentMeta.label}</span>)}
                  id={'doc-tooltip'}
                />
              )}
              <br/>
            </React.Fragment>
          );
        })
      }</div>
      <ExitModal
        settings={settings}
        styleSheet={styleSheet}
        showExitModal={showExitModal}
        handleHide={handleHide}
        handleOpenDocument={handleOpenDocument}
      />
    </>
  );
};

